
(function ( $, Drupal, drupalSettings) {

    // google map for contact page
    // @see https://snazzymaps.com/editor/edit-my-style/271785
    const stylesArray = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#b87376"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#951820"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#531014"
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "weight": "2"
                },
                {
                    "invert_lightness": true
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "lightness": "-1"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "lightness": "0"
                },
                {
                    "saturation": "0"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "weight": "0.01"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "weight": "0.01"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#91023c"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#891041"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#750e38"
                }
            ]
        },
        {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#99282f"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#83181e"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#7c141b"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#592124"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#933137"
                }
            ]
        }
    ];


    /**
     * Initializes the map.
     */
    function init( addresses ) {

        if( addresses && addresses.length > 0 ) {

            ( function( objectkey , callback ){

                var check = function(){
                    if( window[objectkey] ) {
                        // object key ready, call callback
                        callback();
                    } else {
                        // wait on next refresh
                        window.requestAnimationFrame( check );
                    }
                };

                check();
            } )( 'google' ,  function(){

                var i, basePath, map;

                basePath = window.location.protocol+'//'+window.location.hostname+(window.location.port?':'+window.location.port:'');

                map = new google.maps.Map(document.getElementById('js-addresses-map'), {
                    scrollwheel: false,
                    center: new google.maps.LatLng(49.614204, 6.1688253),
                    zoom: 10,
                    styles: stylesArray,
                    zoomControl: true,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL,
                    },
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                });

                var markers = new Array();

                for ( i in addresses) {
                    var address = addresses[i];
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(address['lat'], address['lng']),
                        map: map,
                        title: address.title,
                        icon: basePath+address.icon,
                    });
                    markers.push(marker);
                    google.maps.event.addListener(marker, 'click', function() {
                        var url = "https://www.google.com/maps/search/?api=1&query=" + this.position;
                        window.open(url, '_blank');
                    });
                }

                var bounds = new google.maps.LatLngBounds();
                $.each(markers, function (index, marker) {
                    bounds.extend(marker.position);
                });
                map.panToBounds(bounds);    //   auto-center
                map.fitBounds(bounds);      //   auto-zoom
            } );
        }
    }

    Drupal.behaviors.customMapBehavior = {
        attach: function (context, settings) {
            init( settings.addresses );
        }
    };

})(jQuery, Drupal, drupalSettings);
